export const BRAND_CONSTS = {
    GET_BRANDS: "GET_BRANDS",
    ADD_BRAND: "ADD_BRAND",
    UPDATE_BRAND: "UPDATE_BRAND",
    DELETE_BRAND: "DELETE_BRAND",
    APPEND_BRAND: "APPEND_BRAND",
};
